import React, { useEffect, useState } from "react";
import "./VoucherDefaultOrderPage.scss"
import { useSelector } from "react-redux";
import { getLocalStorageData, LOCAL_STORAGE_ITEMS_NAMES } from "../../../RestaurantWidget/utilities/helper/helper";
import { getOrderHistory } from "../../../RestaurantWidget/utilities/api/restaurantsService";
import moment from "moment";
import Footer from "../../components/Footer/Footer";
import IMAGE_PLACEHOLDER from '../../assets/images/Images/vouchers-placeholder.jpg'


const VoucherDefaultOrderHistoryPage = () => {
    const [data, setData] = useState([])
    useEffect(() => {
        const fetchData = async () => {
            const val = await getLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CART_DATA);
            getOrderHistory(val.cloudLocationID).then((res) => {
                setData(res.reverse())
            })

        }
        fetchData()
    }, [])
    const getPrice = (
        basePrice
        , type
    ) => {
        let priceValue;
        switch (type) {
            case "DELIVERY_BY_REWARDCONSUMER":
                priceValue = basePrice.Delivery.FormattedText;
                break;
            case "DINE_IN":
                priceValue = basePrice.DineIn.FormattedText;
                break;
            case "TAKE_AWAY":
                priceValue = basePrice.TakeAway.FormattedText;
                break;
            default:
                priceValue = basePrice.Delivery.FormattedText;
                break;
        }
        return priceValue
    }
    const renderModifierGroups = (selectedGroup) => {
        return (
            <div>
                <span>{selectedGroup.Title} ({selectedGroup.Quantity.Amount})</span>
                {selectedGroup.SelectedItems.map((selectedItem, index) => (
                    <span key={index}>
                        <span className="addon-title">
                            {selectedItem.Title} ({getPrice(selectedItem.PriceInfo.BaseTotalPrice)})
                        </span>
                        {selectedItem.SelectedModifierGroups && selectedItem.SelectedModifierGroups.length > 0 && (
                            <span>
                                {selectedItem.SelectedModifierGroups.map((nestedGroup, nestedIndex) => (
                                    <span key={nestedIndex}> {renderModifierGroups(nestedGroup)}</span>
                                ))}
                            </span>
                        )}
                        {index < selectedGroup.SelectedItems.length - 1 && <span>, </span>}
                    </span>
                ))}
            </div>
        );
    };

    return (
        <div className='VoucherDefaultOrderPage '>
            <div className="Order-confirmation">
                <div className="Order-confirmation-header">
                    <div className="header-text-cont">Order History</div>

                </div>
                <div className="Order-confirmation-inner">
                    <div className="eco-mb-16 Order-confirmation-inner-left ">
                        <div className="order-form-summary  eco-mb-36">

                            {data.length > 0 && data.map((value) => {
                                return (
                                    <div className="order-history-container">
                                        <div className="order-history-conatiner-header">
                                            <div className="header-cont"><div className="header-text">Status</div><div className="sub-text">{value?.Status}</div></div>
                                            <div className="header-cont"><div className="header-text center">Order ID</div><div className="sub-text center">{value?.OrderID}</div></div>
                                            <div className="header-cont"><div className="header-text center">Total</div><div className="sub-text center">{value?.Payment?.PaymentDetail?.
                                                OrderTotal.Net.Formatted}</div></div>
                                            <div className="end-cont"><div className="details-btn">See Details</div></div>
                                        </div>
                                        <div className="order-history-details-container">
                                            <div className="status-header">{value?.Status.toLowerCase()}: {moment(new Date(value.ScheduledOrderTargetDeliveryTimeRange.EndTime)).format('D MMM, YYYY')}</div>
                                            {value.Carts.Items.map((item) => {
                                                return (
                                                    <div className="items-list-container">
                                                        <div className="items-list-container-left">
                                                            <div className="image-container">
                                                                <img alt="" src={item.PictureURL !== "" ? item.PictureURL : IMAGE_PLACEHOLDER} className="image-div" style={{ objectFit: item.PictureURL === "" ? "fill" : "" }} />
                                                            </div>
                                                            <div className="item-details">
                                                                <div className="name">{item.Title}</div>
                                                                <div className="des-val">{item.SelectedModifierGroups.map((selectedGroup, index) => (
                                                                    <span key={index}> {renderModifierGroups(selectedGroup)} </span>
                                                                ))}</div>
                                                                <div className="price">{getPrice(item.PriceInfo.TotalPrice, value.FulfillmentType)}</div>
                                                            </div>
                                                        </div>
                                                        <div className="items-list-container-right">Qty: {item.Quantity.Amount}</div>
                                                    </div>
                                                )
                                            })

                                            }
                                        </div>
                                    </div>
                                )
                            })

                            }
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </div>

    )
}
export default VoucherDefaultOrderHistoryPage